var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.logo{fill:#00547F;}\n"),React.createElement("path",{"className":"logo","d":"M70.4,19.1c4.5,2.3,20.7,8,36.4,10.3c14.6,2.1,26.4-2.4,37.2-7.2c0,0-17.5,20.8-40.9,20.2\n\tc-22.2-0.5-37.1-15.8-57.9-20c-18-3.7-45.2,7.7-45.2,7.7s22-14.9,41.7-17.1c0,0-14.4-16.2-34.9-6.3c0,0,14.9-12.4,30.5-4.3\n\tc10.5,5.5,15.6,9,26,9c0,0,20.4,0.4,32.7-8.3C96.1,3.2,87.4,15.1,70.4,19.1z","key":1})]);
}

Logo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 144 42","style":{"enableBackground":"new 0 0 144 42"},"xmlSpace":"preserve"};

module.exports = Logo;

Logo.default = Logo;



//////////////////
// WEBPACK FOOTER
// ./src/img/svg/logo.svg
// module id = 250
// module chunks = 104101334113578 114276838955818